import type {Params} from "next/dist/server/request/params";
import {baseAppDirname} from "@/config/constants";
import {resolvePagePath} from "@/utils/path";
import type {Breadcrumb} from "../types";

const breadcrumbsByDirname: Record<string, Breadcrumb> = {};
let lastDirname: string;
let cachedParams: Params;

export function addBreadcrumb(breadcrumb: Breadcrumb, params?: Params)
{
    breadcrumb.dirname = resolvePagePath(breadcrumb.dirname, undefined, baseAppDirname);

    if (breadcrumb.menu) 
    {
        for (const item of breadcrumb.menu)
            item.dirname = resolvePagePath(item.dirname, undefined, baseAppDirname);
    }

    breadcrumbsByDirname[breadcrumb.dirname] = breadcrumb;
    lastDirname = breadcrumb.dirname;

    if (params)
        cachedParams = params;
}

export function getBreadcrumbs(pathname?: string, params?: Params)
{
    pathname = pathname || lastDirname;
    params = params || cachedParams;

    if (!pathname)
        return;

    pathname = resolvePagePath(pathname, params);

    const breadcrumbsByPathname: typeof breadcrumbsByDirname = {};

    for (const dirname in breadcrumbsByDirname)
    {
        const pathname = resolvePagePath(dirname, params);
        const breadcrumb = breadcrumbsByDirname[dirname];
        breadcrumbsByPathname[pathname] = {...breadcrumb, href: breadcrumb.href ?? (pathname.includes("[") ? undefined : pathname)};

        if (breadcrumb.menu)
        {
            for (const item of breadcrumb.menu)
            {
                const pathname = resolvePagePath(item.dirname, params);
                item.href = item.href ?? (pathname.includes("[") ? undefined : pathname);
            }
        }
    }

    const breadcrumbs: Breadcrumb[] = [];
    const segments = pathname.split("/");
    let shrinkingPathname = pathname;

    while (shrinkingPathname in breadcrumbsByPathname && segments.length)
    {
        breadcrumbs.push(breadcrumbsByPathname[shrinkingPathname]);

        if (shrinkingPathname === "/")
            break;

        segments.pop();
        shrinkingPathname = segments.join("/") || "/";
    }

    breadcrumbs.sort((a, b) => a.dirname.length - b.dirname.length);

    return breadcrumbs;
}
